import React, { useLayoutEffect, useRef } from 'react';

// Een regel zonder woorden (alleen akkoorden, maatstrepen, herhalingstekens): een akkoordrij zoals in een zangbundel.
export const isChordOnly = (line) => line.segments.some((part) => part.chord)
  && line.segments.every((part) => !/[\p{L}\p{N}]/u.test(part.text.replace(/\bx\d+\b|\b\d+x\b/gi, '')));

// Een akkoord staat als nulbreed anker op zijn plek in de doorlopende tekst. De tekst is dus één gewone, doorlopende
// regel: de breedte van een akkoord (C#m7, D/F#) kan de tekst nooit verschuiven. Alleen het akkoordlabel zelf
// schuift zo nodig een stukje op als twee akkoorden elkaar anders zouden overlappen.
export const ChordAnchoredLine = ({ line, className }) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const root = ref.current;
    if (!root) return undefined;
    const spread = () => {
      const chords = [...root.querySelectorAll('.chordpro-chord')];
      chords.forEach((chord) => { chord.style.transform = ''; });
      const rows = new Map();
      chords.forEach((chord) => {
        const rect = chord.getBoundingClientRect();
        const key = Math.round(rect.top);
        rows.set(key, [...(rows.get(key) || []), { chord, rect }]);
      });
      rows.forEach((row) => {
        let edge = -Infinity;
        row.sort((a, b) => a.rect.left - b.rect.left).forEach(({ chord, rect }) => {
          const shift = Math.max(0, edge + 4 - rect.left);
          if (shift > 0) chord.style.transform = `translateX(${shift}px)`;
          edge = rect.left + shift + rect.width;
        });
      });
    };
    spread();
    window.addEventListener('resize', spread);
    return () => window.removeEventListener('resize', spread);
  });
  // Woorden (met de akkoordankers erin) mogen niet afbreken: een browser ziet een anker mid-woord anders als
  // afbreekpunt en zou "bou|wen" over twee regels verdelen. Tussen woorden blijft de tekst gewoon doorlopen.
  const parts = [];
  let word = [];
  const flush = () => { if (word.length) parts.push(<span key={parts.length} className="chordpro-word">{word}</span>); word = []; };
  const onlyChordsFollow = (segmentIndex, pieceIndex) => {
    const pieces = line.segments[segmentIndex].text.split(/(\s+)/);
    if (pieces.slice(pieceIndex + 1).some((piece) => piece.trim())) return false;
    return line.segments.slice(segmentIndex + 1).every((next) => !next.text.trim()) && word.length > 0;
  };
  line.segments.forEach((part, index) => {
    if (part.chord) word.push(<span key={`c${index}`} className="chordpro-anchor"><strong className="chordpro-chord">{part.chord}</strong></span>);
    part.text.split(/(\s+)/).forEach((piece, pieceIndex) => {
      if (!piece) return;
      // Spaties tussen de laatste woorden en een afsluitend akkoord (de plek van het akkoord in de bron) zijn geen tekst:
      // anders valt dat akkoord op een eigen regel onder de tekst.
      if (/^\s+$/.test(piece)) { if (!onlyChordsFollow(index, pieceIndex)) { flush(); parts.push(piece); } } else word.push(piece);
    });
  });
  flush();
  return <div ref={ref} className={className}>{parts}{!parts.length && ' '}</div>;
};

export const ChordRow = ({ line, className }) => <div className={`${className} chordpro-chord-row`}>{line.segments.map((part, index) => <React.Fragment key={index}>
  {part.chord && <strong className="chordpro-chord-inline">{part.chord}</strong>}
  {part.text.split(/(\s+)/).map((piece, pieceIndex) => (/^\s*$/.test(piece) ? piece : <span key={pieceIndex} className="chordpro-bar">{piece}</span>))}
</React.Fragment>)}</div>;
